/**
 * Functions to upload files using HTML5
 * 
 */

$(function() {

  var FormId;
  var FileListId;
  var Uploading = false;  // check for uploading images
  var NumUploadsPending;
  var NumUploadFailures;
  var IsImageUpload;

  // Store the 'image metadata saved to DB but image file save pending' image ids in their own Array; we initially
  // tried storing this on the File objects themselves (as ".imageId"), but that property was mysteriously getting
  // removed indeterminately, ostensibly by the browser during garbage collection.
  // Legacy implementation (i.e. "cruft") to address an Adobe bug: kb400730
  var FileIds = [];

  function checkUnload () {
    if (Uploading) {
      return 'Files are still uploading.  Leaving this page will cause the pending uploads to fail.';
    }
  }

  function selectedFilesChanged (fileList, id) {
    FormId = id;
	FileListId = id + 'FileList';

	var form = document.getElementById(FormId);

    var filenames = [];
    if (!fileList) {
      var filepath = form.querySelector('#upload_files').value;
      var filename = filepath.match(/[^\/\\]+$/);
      filenames.push(filename);
    } else {
      for (var i = 0, len = fileList.length; i < len; ++i) {
        filenames.push(fileList[i].name);
      }
    }

    var tableName = form.querySelector('#TableName').value;
    var ULElement = form.querySelector('#' + FileListId);

    // Remove previous list (if any)
    if (ULElement.hasChildNodes()) {
      while (ULElement.childNodes.length > 0) {
        ULElement.removeChild(ULElement.firstChild);
      }
    }

    // append a <LI> for each file selected
    for (i = 0, len = filenames.length; i < len; ++i) {
      var LIElement = ULElement.appendChild(document.createElement('li'));
      LIElement.appendChild(document.createTextNode(' ' + filenames[i] + ' '));
      LIElement.appendChild(document.createElement('br'));
	
      // create an img element which is the progress bar
      var ProgressImg = document.createElement('img');
      ProgressImg.setAttribute('id', FileListId + 'File' + i);
      ProgressImg.setAttribute('class', 'percentImage1');
      ProgressImg.setAttribute('style', 'background-position: -102px 0pt;');
      ProgressImg.setAttribute('src', '/ProgressBar/percentImage.png');
      //For IE we have to append the child after setting class and style
      LIElement.appendChild(ProgressImg);

      var ProgressSpan = LIElement.appendChild(document.createElement('span'));
      ProgressSpan.setAttribute('id', FileListId + 'File' + i + 'Text');
      ProgressSpan.setAttribute('style', 'white-space: nowrap;');
      setProgress(FileListId + 'File' + i, 0, '&nbsp;Upload Not Started');
    }
  }


  /**
   * Go!  The 'add' button's click handler - starts the upload process!
   * Saves files' metadata to the DB, creating new records; the 'save response received'
   * callback will upload the files to the appropriate server.
   * @return  Boolean indicating whether one or more files were selected for uploading
   */
  function uploadFiles () {

    var fileType, fileTypes, recordsURL;
    var isDocumentUpload = false;
	var form = document.getElementById(FormId);
	if (form === null)
	  return;
    var tableName = form.querySelector('#TableName').value;
    if (tableName === 'Image') {
      IsImageUpload = true;
      fileType = 'Image';
      fileTypes = 'Images';
      recordsURL = '/DoAddImageZFU.php';
    } else {
      IsImageUpload = false;
      isDocumentUpload = true;
      fileType = 'Document';
      fileTypes = 'Documents';
      recordsURL = "/Document_Save.php?ZFUUpload=1&Records=1";
    }

    var fileInput = form.querySelector('#upload_files');
    var filesToUpload = fileInput.files;
    if (!filesToUpload || filesToUpload.length === 0) {
      // This check needs to be performed again, as this method can be called from outside the scope of this page!
      if ($('#' + FileListId + ' > li').length === 0) {
        return false;
      }

      var filepath = form.querySelector('#upload_files').value;
      var filename = filepath.match(/[^\/\\]+$/);
      filesToUpload = [{ name: filename, size: 0 }];
    }

    FileIds = [];
    NumUploadsPending = filesToUpload.length;

    var xmlDoc = document.implementation.createDocument('', fileTypes, null);
    var xmlNodes = xmlDoc.documentElement;

    var parentTableName = form.querySelector('#ParentTableName').value;
    var parentId = form.querySelector('#ParentId').value;
    if (isDocumentUpload)
      var description = form.querySelector('#Description').value;

    for (var i = 0, len = filesToUpload.length; i < len; ++i) {
      var currentFile = filesToUpload[i];
      var xmlNode = xmlDoc.createElement(fileType);
      xmlNode.setAttribute('ParentTableName', parentTableName);
      xmlNode.setAttribute('ParentId', parentId);
      if (isDocumentUpload) {
        xmlNode.setAttribute('Description', description);
        xmlNode.setAttribute('OriginalFileName', currentFile.name);
      }
      xmlNodes.appendChild(xmlNode);
    }

    // get the XML as a string
    var serializer = new XMLSerializer();
    var stringXML = serializer.serializeToString(xmlDoc.documentElement);
    SpectrumMessageBox('Creating ' + fileType + ' Records...');
    var key = fileTypes + 'XML';
    var postData = {};
    postData[key] = stringXML;

    // Add Records to DB, if successful upload files
    $.post(recordsURL, postData)
      .done(function (data) {
        var xmlString = ParseAjaxResponse(data);
        if (typeof xmlString !== 'string')
          return;
        var xmlDoc = getXMLDocFromXMLString(xmlString);

        // Determine valid uploads
        var nodes = xmlDoc.getElementsByTagName(fileType);
        for (var i = 0, len = nodes.length; i < len; ++i) {
          var node = nodes[i];
          var errorNodes = node.getElementsByTagName('error');
          if (errorNodes.length == 0) {
            var id = nodes[i].getAttribute("Id");
            FileIds.push(id);
            Uploading = true;
          } else {
            FileIds.push(0);  // flag to not upload
            var progressId = FileListId + 'File' + i;
            var errorMsg = errorNodes[0].firstChild.nodeValue;
            setProgress(progressId, 0, ' Upload Failed - ' + errorMsg);
          }
        }

        if (Uploading) {
          // Start uploading the images.
          NumUploadFailures = 0;
          SpectrumMessageBox('Uploading files. Please wait...');
          if (filesToUpload.length > 0) {
            if (IsImageUpload)
              uploadAllImages(filesToUpload);
            else
              uploadAllFiles(filesToUpload);
          }
        } else {
          HideSpectrumMessageBox();
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        alert('Upload Failed: ' + errorThrown);
        HideSpectrumMessageBox();
      });

    return true;
  }

  function uploadAllImages (imageFiles) {
    var form = document.getElementById(FormId);
    var urlBase = form.querySelector('#ImageServerURL').value;
    for (var i = 0, len = imageFiles.length; i < len; ++i) {
      // Set the progress text to '10% complete' (an approximation) as the image metadata has already been saved.
      var fileSizeKb = (imageFiles[i].size / 1024).toFixed(1);    // One digit after the decimal point.
      setProgress(FileListId + 'File' + i, 10, ' Uploading (0 of ' + fileSizeKb + ' KB)');
      var url = urlBase + '/@' + FileIds[i] + '?UPLOAD';
      uploadFile(i, imageFiles[i], url);
    }
  }

  function uploadAllFiles (files) {
    var urlBase = "/Document_Save.php?ZFUUpload=1";
    for (var i = 0, len = files.length; i < len; ++i) {
      if (FileIds[i] !== 0) {
        // Set the progress text to '10% complete' (an approximation) as the file metadata has already been saved.
        var fileSizeKb = (files[i].size / 1024).toFixed(1);    // One digit after the decimal point.
        setProgress(FileListId + 'File' + i, 10, ' Uploading (0 of ' + fileSizeKb + ' KB)');
        var url = urlBase + "&Id=" + FileIds[i];
        uploadFile(i, files[i], url);
      }
    }
  }

  function uploadFile (fileIndex, theFile, uploadUrl) {

    var progressId = FileListId + 'File' + fileIndex;
    var fileAsFormData = getFileAsFormData(theFile);

    if (fileAsFormData) {
      var args = {
        type: 'post',
        url: uploadUrl,
        data: fileAsFormData,
        processData: false,
        contentType: false,
      }
      if (IsImageUpload) {
        args['xhr'] = function () {
          var xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener('progress', onUploadProgress, false);
          }
          return xhr;
        }
      }

      $.ajax(args)
          .done(onSuccess)
          .fail(onFail)
          .always(onAlways);
    }

    function onUploadProgress (progressEvent) {
      var progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      setProgress(progressId, progress, ' Uploading (' + progressEvent.loaded + ' of ' + progressEvent.total + ' KB)');
    }

    function onSuccess (data) {
      if (data && typeof data == 'string') {
        if (IsImageUpload) {
          var results = data.split('|');
          var xfrProgress = (results.length > 0) ? parseInt(results[results.length - 1]) : 100;
          setProgress(progressId, xfrProgress, ' Upload Complete');
        } else {
          var status = ParseAjaxResponse(data); // Display any standard eSM errors
          if (status == 'success')
            setProgress(progressId, '100', ' Upload Complete');
           else
            setProgress(progressId, 0, ' Upload Failed - ' + Status);
        }
      }
    }

    function onFail (jqXHR, textStatus, errorThrown) {
      var rt = jqXHR.responseText;
      setProgress(progressId, 0, ' Upload Failed - ' + errorThrown + ': ' + rt);

      // Remove the failed entry from the db
      var id = FileIds[fileIndex];
      if (IsImageUpload) {
        $.post('/Record_Delete.php?TableName=Image&ImageIds[]=' + id);
      } else {
        var form = document.getElementById(FormId);
        var tableName = form.querySelector('#TableName').value;
        $.post('/Record_Delete.php?TableName=' + tableName + '&Ids[]=' + id);
      }

      ++NumUploadFailures;
    }

    function onAlways () {
      NumUploadsPending--;
      if (NumUploadsPending === 0) {
        Uploading = false;
        SpectrumMessageBox('Finalizing...');
        // wait 1 second for imageserver to update the transfer progress
        // in the database, then redirect to the parent page
        if (NumUploadFailures === 0) {
          setTimeout(FileAddRedirect, 1000);
          $(document).trigger("FileUploadComplete", '');
        }
      }
      if (NumUploadFailures > 0) {
        HideSpectrumMessageBox();
      }
    }

    function FileAddRedirect () {
      // switch to EditRecord if not running in PAL Mode
      if (false === isPALMode()) {
        var form = document.getElementById(FormId);
        var parentTableName = form.querySelector('#ParentTableName').value;
        var parentId = form.querySelector('#ParentId').value;
        window.location = "/EditRecord.php?TableName=" + parentTableName + "&Ids[]=" + parentId;
      } else {
        // add the image thumbnail to the specimen page
        if (FileIds.length > 0) { // for healthcare, the length should always be 1
          var imageId = FileIds[0];
          jsCaseAssemblySpecimen.addSpecimenImageThumbnail(imageId);
          $('#addImageDlg').dialog('close');
          HideSpectrumMessageBox();
        }
      }
    }
  }

  function getXMLDocFromXMLString (xmlString) {
    var parser = new DOMParser();
    xmlDoc = parser.parseFromString(xmlString, 'text/xml');
    return xmlDoc;
  }

  function getFileAsFormData (file) {
    if (!window.FormData) {
      return null;
    }
    var formData = new FormData();
    formData.append('Filename', file.name);
    formData.append('Filedata', file);
    return formData;
  }

  window.checkUnload = checkUnload;
  window.selectedFilesChanged = selectedFilesChanged;
  window.uploadFiles = uploadFiles;

});

